import { LitElement, html } from 'lit';
import { styles } from '../view/styles';
import { ExchangeProtectionDetailsPanel } from '../types';
import { SideMenuEvents } from '../../../ui/gzSideMenu/types';
import { GzTooltip } from 'apps/webcomponents/src/ui/gzTooltip';

export class ExchangeProtectionDetailsPanelWebComponent extends LitElement {
  panelConfig: ExchangeProtectionDetailsPanel;
  static get styles() {
    return styles;
  }

  protected render() {
    return html`
      <div class="details-panel--container">
        <header class="details-panel--header">
          <gz-title class="title" fontweight="500" fontsize="16">${this.panelConfig?.details}</gz-title>
        </header>

        <section class="details-panel--content">
          <div class="content-detection">
            <div class="content-detection--title mb-2 mt-2">${this.panelConfig?.detectionDetails?.title}</div>
            <div>${this.renderBody(this.panelConfig?.detectionDetails)}</div>
          </div>

          <div class="content-message">
            <div class="content-message--title mb-2 mt-2">${this.panelConfig?.message?.title}</div>
            <div>${this.renderBody(this.panelConfig?.message)}</div>
          </div>
        </section>

        <footer class="details-panel--footer">
          <gz-button id="closePanel" @click="${this.handleClosePanel}">${this.panelConfig?.close}</gz-button>
        </footer>
      </div>
    `;
  }

  private handleClosePanel() {
    const event = new CustomEvent(SideMenuEvents.CLOSE, {
      detail: {},
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  private renderContent(content: { label: string; value: string }) {
    if (!(content?.label && content?.value)) {
      return;
    }

    return html`<div class="d-flex mb-2 mt-2">
      <div class="content--label">${content?.label}</div>
      <div @mouseenter="${this.handleMouseEnter}" @mouseleave="${this.handleMouseLeave}" class="content--value">
        ${content?.value}
      </div>
    </div>`;
  }

  private renderBody(panelConfig) {
    return Object.entries(panelConfig).map(([key]) => this.renderContent(panelConfig[key]));
  }

  private handleMouseEnter(event: MouseEvent) {
    const item = event.target as HTMLElement;

    if (item.clientWidth >= 200) {
      GzTooltip.show(item.innerText, event);
    }
  }

  private handleMouseLeave() {
    GzTooltip.hide();
  }
}
